var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "\r\n\r\n<div class=\"container\">\r\n    \r\n    "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? depth0.component : depth0)) != null ? stack1.html : stack1), depth0)) != null ? stack1 : "")
    + "\r\n    <br />\r\n    <div id=\"errorBox\" class=\"alert alert-danger\" style=\"display:none;\">\r\n        <strong>Der opstod en fejl: </strong> <span id=\"errorMessageBox\"></span>\r\n    </div>\r\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/component/app.hbs
// module id = 17
// module chunks = 0